import AdminProductActionModal from 'components/AdminProductActionModal/AdminProductActionModal';
import ProductService from 'services/product.service';

const productService = new ProductService();

type Props = {
  opened: boolean;
  product: any;
  close: () => void;
  refreshParentDataFn?: () => void;
};

// Admin-only dialog for hiding other users' products
// Does NOT update my-shop Redux state since it operates on other users' products
const HideProductDialog = (props: Props) => {
  const { opened, product, close, refreshParentDataFn } = props;

  const hideProduct = async ({
    reason: hideReason,
    comment: hideComment,
    reasonType: hideReasonType,
  }: {
    reason: string;
    comment: string;
    reasonType: string;
  }) => {
    await productService.hideProduct(product.id, {
      statusParams: {
        hideComment,
        hideReason,
        hideReasonType,
      },
      hide: true,
    });
  };

  return (
    <AdminProductActionModal
      opened={opened}
      onClose={close}
      onAction={hideProduct}
      refreshParentDataFn={refreshParentDataFn}
      reasonService={productService.getHideReasons}
      translationStrings={{
        actionButton: 'components.admin.product.hide',
        actionSuccess: 'components.admin.product.reason.hide-success',
        actionNoReasonError: 'components.admin.product.reason.hide-error',
      }}
    />
  );
};

export default HideProductDialog;
